export function formatEmailBody(body: string): string {
	return (body || '')
		.split('\n')
		.map(
			line =>
				`<div style="line-height: 1.25; min-height: 1.25em;">${line}</div>`,
		)
		.join('\n');
}
